// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   VOICE INTERVIEW SCREEN - G42 BRANDING
   Dark theme for interview experience
   ========================================== */

:root {
  --voice-bg-dark: #0A1F1C;
  --voice-bg-darker: #071613;
  --voice-card-bg: #0F2A25;
  --voice-card-light: #13342E;
  --voice-text-primary: #E5F2ED;
  --voice-text-secondary: #A8C5BB;
  --voice-text-muted: #6B8B7F;
  --voice-border: #1A3F38;
  --voice-accent: var(--interview-brand-primary);
  --voice-accent-hover: var(--interview-brand-primary-hover);
  --voice-recording: #DC2626;
  --voice-proctored: var(--interview-brand-primary);
}

.voice-interview-container {
  height: 100vh; /* Fixed height instead of min-height */
  background: var(--voice-bg-dark);
  display: flex;
  flex-direction: column;
  font-family: var(--interview-font-primary);
  color: var(--voice-text-primary);
  position: relative;
  overflow: hidden; /* Prevent body scroll */
  /* No extra padding needed - video is floating in top-right corner */
}

/* ========== HEADER ========== */
.voice-interview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: var(--voice-bg-darker);
  border-bottom: 1px solid var(--voice-border);
  gap: 24px;
}

.voice-interview-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.voice-interview-logo {
  flex-shrink: 0;
}

.voice-interview-brand-text {
  font-size: 15px;
  font-weight: 800;
  color: var(--voice-text-primary);
}

.voice-interview-header-badges {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.voice-interview-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid;
}

.voice-interview-badge-recording {
  background: rgba(220, 38, 38, 0.1);
  border-color: rgba(220, 38, 38, 0.3);
  color: #FCA5A5;
}

.voice-interview-recording-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--voice-recording);
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.voice-interview-badge-proctored {
  background: rgba(15, 157, 107, 0.1);
  border-color: rgba(15, 157, 107, 0.3);
  color: #6EE7B7;
}

.voice-interview-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.voice-interview-person-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--voice-text-secondary);
  background: var(--voice-card-bg);
  padding: 8px 14px;
  border-radius: 20px;
  border: 1px solid var(--voice-border);
}

.voice-interview-timer-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--voice-card-bg);
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid var(--voice-border);
}

.voice-interview-timer {
  font-size: 14px;
  font-weight: 600;
  color: var(--voice-text-primary);
  font-variant-numeric: tabular-nums;
}

.voice-interview-toggle-btn {
  background: var(--voice-card-bg);
  border: 1px solid var(--voice-border);
  color: var(--voice-text-secondary);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.voice-interview-toggle-btn:hover {
  background: var(--voice-card-light);
  color: var(--voice-text-primary);
  border-color: var(--voice-accent);
}

/* ========== MAIN CONTENT ========== */
.voice-interview-content {
  flex: 1;
  display: flex;
  gap: 24px;
  padding: 24px;
  padding-right: 356px; /* 300px video width + 28px right margin + 28px gap */
  overflow: hidden; /* Prevent main content from scrolling */
  max-height: calc(100vh - 160px); /* Header + Footer height */
}

/* Responsive adjustments for video clearance */
@media (max-width: 768px) {
  .voice-interview-content {
    padding-right: 244px; /* 220px video width + 12px right margin + 12px gap */
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .voice-interview-content {
    padding-right: 300px; /* 260px video width + 28px + 12px gap */
  }
}

/* ========== TRANSCRIPT SECTION ========== */
.voice-interview-transcript-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--voice-card-bg);
  border-radius: 16px;
  border: 1px solid var(--voice-border);
  overflow: hidden; /* Important: prevents section from growing */
  min-height: 0; /* Important: allows flex item to shrink below content size */
  max-width: 100%; /* Prevent overflow */
}

.voice-interview-question-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--voice-border);
}

.voice-interview-question-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: var(--voice-accent);
  display: block;
  margin-bottom: 12px;
}

.voice-interview-progress-bar {
  height: 6px;
  background: var(--voice-bg-darker);
  border-radius: 3px;
  overflow: hidden;
}

.voice-interview-progress-fill {
  height: 100%;
  background: var(--voice-accent);
  border-radius: 3px;
  transition: width 0.5s ease;
}

.voice-interview-hint {
  padding: 0 24px;
  font-size: 12px;
  color: var(--voice-text-muted);
  margin: 12px 0;
}

.voice-interview-transcript {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.voice-interview-transcript::-webkit-scrollbar {
  width: 8px;
}

.voice-interview-transcript::-webkit-scrollbar-track {
  background: var(--voice-bg-darker);
  border-radius: 4px;
}

.voice-interview-transcript::-webkit-scrollbar-thumb {
  background: var(--voice-border);
  border-radius: 4px;
}

.voice-interview-transcript::-webkit-scrollbar-thumb:hover {
  background: var(--voice-card-light);
}

.voice-interview-transcript-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--voice-text-muted);
  font-size: 14px;
}

.voice-interview-message {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  max-width: 85%;
}

/* Agent messages aligned left */
.voice-interview-message-agent {
  align-self: flex-start;
}

/* Candidate messages aligned right */
.voice-interview-message-candidate {
  align-self: flex-end;
  flex-direction: row-reverse; /* Avatar on the right */
  margin-left: auto;
}

.voice-interview-message-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
}

.voice-interview-message-agent .voice-interview-message-avatar {
  background: #0A6E4A;
  color: #fff;
}

.voice-interview-message-candidate .voice-interview-message-avatar {
  background: #3D5560;
  color: #fff;
}

.voice-interview-message-bubble {
  flex: 1;
  padding: 13px 17px;
  border-radius: 16px;
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--voice-text-primary);
  word-wrap: break-word;
}

.voice-interview-message-agent .voice-interview-message-bubble {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #D8EFE4;
  border-top-left-radius: 4px;
}

.voice-interview-message-candidate .voice-interview-message-bubble {
  background: var(--voice-accent);
  color: #fff;
  border-top-right-radius: 4px;
}

.voice-interview-listening-indicator {
  display: flex;
  justify-content: center;
  padding: 16px;
}

.voice-interview-dot-wave {
  display: flex;
  gap: 6px;
  align-items: center;
}

.voice-interview-dot-wave span {
  width: 8px;
  height: 8px;
  background: var(--voice-accent);
  border-radius: 50%;
  animation: wave 1.2s ease-in-out infinite;
}

.voice-interview-dot-wave span:nth-child(2) {
  animation-delay: 0.2s;
}

.voice-interview-dot-wave span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes wave {
  0%, 60%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  30% {
    transform: scale(1.3);
    opacity: 1;
  }
}

.voice-interview-instructions {
  padding: 16px 24px;
  border-top: 1px solid var(--voice-border);
  font-size: 12px;
  color: var(--voice-text-muted);
  text-align: center;
}

/* ========== VIDEO SECTION ========== */
.voice-interview-video-section {
  width: 320px;
  flex-shrink: 0;
  position: relative;
  background: var(--voice-bg-darker);
  border-radius: 16px;
  border: 1px solid var(--voice-border);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.voice-interview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1);
}

.voice-interview-video-label {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(10, 31, 28, 0.9);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  color: var(--voice-text-secondary);
  border: 1px solid var(--voice-border);
}

/* ========== FOOTER CONTROLS ========== */
.voice-interview-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px 24px;
  background: var(--voice-bg-darker);
  border-top: 1px solid var(--voice-border);
}

.voice-interview-mic-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--voice-accent);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.voice-interview-mic-btn:hover:not(:disabled) {
  background: var(--voice-accent-hover);
  transform: scale(1.05);
}

.voice-interview-mic-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.voice-interview-mic-btn.voice-interview-mic-muted {
  background: var(--voice-recording);
}

.voice-interview-listening-bar {
  flex: 1;
  max-width: 400px;
  height: 56px;
  background: var(--voice-card-bg);
  border-radius: 28px;
  border: 1px solid var(--voice-border);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 24px;
}

.voice-interview-sound-bars {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 28px;
}

.voice-interview-sound-bar {
  width: 3px;
  background: var(--voice-accent);
  border-radius: 2px;
  animation: sound-bar 1s ease-in-out infinite;
}

@keyframes sound-bar {
  0%, 100% { height: 8px; }
  50% { height: 24px; }
}

.voice-interview-listening-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--voice-accent);
}

.voice-interview-listening-text.voice-interview-listening-idle {
  color: var(--voice-text-muted);
}

.voice-interview-action-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.voice-interview-pause-btn,
.voice-interview-end-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--interview-font-primary);
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid var(--voice-border);
}

.voice-interview-pause-btn {
  background: var(--voice-card-bg);
  color: var(--voice-text-primary);
}

.voice-interview-pause-btn:hover:not(:disabled) {
  background: var(--voice-card-light);
  border-color: var(--voice-accent);
}

.voice-interview-pause-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.voice-interview-end-btn {
  background: transparent;
  color: var(--voice-text-secondary);
}

.voice-interview-end-btn:hover:not(:disabled) {
  background: rgba(220, 38, 38, 0.1);
  border-color: var(--voice-recording);
  color: #FCA5A5;
}

.voice-interview-end-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ========== OVERLAYS ========== */
.voice-interview-start-overlay,
.voice-interview-connecting-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 31, 28, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  backdrop-filter: blur(8px);
}

.voice-interview-start-card {
  background: var(--voice-card-bg);
  border: 1px solid var(--voice-border);
  border-radius: 20px;
  padding: 48px 56px;
  text-align: center;
  max-width: 480px;
}

.voice-interview-start-card h2 {
  font-size: 28px;
  font-weight: 700;
  color: var(--voice-text-primary);
  margin: 0 0 16px;
}

.voice-interview-start-card p {
  font-size: 15px;
  color: var(--voice-text-secondary);
  margin: 0 0 32px;
  line-height: 1.6;
}

.voice-interview-start-btn {
  width: 100%;
  padding: 16px 32px;
  background: var(--voice-accent);
  color: white;
  border: none;
  border-radius: 13px;
  font-size: 16px;
  font-weight: 700;
  font-family: var(--interview-font-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.voice-interview-start-btn:hover {
  background: var(--voice-accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(15, 157, 107, 0.3);
}

.voice-interview-connecting-overlay {
  flex-direction: column;
  gap: 20px;
}

.voice-interview-connecting-overlay p {
  font-size: 16px;
  color: var(--voice-text-secondary);
}

.voice-interview-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--voice-border);
  border-top-color: var(--voice-accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ========== RESPONSIVE ========== */
@media (max-width: 1200px) {
  .voice-interview-content {
    flex-direction: column;
  }

  .voice-interview-video-section {
    width: 100%;
    height: 240px;
  }
}

@media (max-width: 768px) {
  .voice-interview-header {
    flex-wrap: wrap;
    gap: 12px;
  }

  .voice-interview-header-right {
    order: 3;
    flex-basis: 100%;
    justify-content: space-between;
  }

  .voice-interview-footer {
    flex-wrap: wrap;
    gap: 12px;
  }

  .voice-interview-listening-bar {
    flex-basis: 100%;
    order: 3;
  }

  .voice-interview-video-section {
    height: 180px;
  }
}

/* ========== COMPLETION SCREEN ========== */
.voice-interview-completion {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: linear-gradient(160deg, #0E2C24 0%, #0A5C3A 60%, #0F9D6B 100%);
  font-family: var(--interview-font-primary);
  text-align: center;
}

.voice-interview-completion-content {
  max-width: 520px;
  width: 100%;
}

.voice-interview-completion-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 48px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
}

.voice-interview-completion-checkmark {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 32px;
  color: #7EEFC4;
}

.voice-interview-completion-title {
  font-size: 36px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.voice-interview-completion-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 42px;
  max-width: 440px;
  margin-left: auto;
  margin-right: auto;
}

.voice-interview-completion-steps {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 42px;
}

.voice-interview-completion-step {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
  transition: background 0.2s ease;
}

.voice-interview-completion-step:hover {
  background: rgba(255, 255, 255, 0.12);
}

.voice-interview-completion-step-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #7EEFC4;
}

.voice-interview-completion-step-text {
  flex: 1;
  padding-top: 2px;
}

.voice-interview-completion-step-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.voice-interview-completion-step-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.voice-interview-completion-link {
  color: #7EEFC4;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 600;
}

.voice-interview-completion-link:hover {
  color: #9FF5D4;
}

.voice-interview-completion-footer {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
  max-width: 420px;
}

/* Responsive for completion screen */
@media (max-width: 768px) {
  .voice-interview-completion {
    padding: 24px 20px;
  }

  .voice-interview-completion-title {
    font-size: 28px;
  }

  .voice-interview-completion-subtitle {
    font-size: 15px;
    margin-bottom: 32px;
  }

  .voice-interview-completion-step {
    padding: 16px;
  }

  .voice-interview-completion-step-icon {
    width: 36px;
    height: 36px;
  }

  .voice-interview-completion-step-title {
    font-size: 14px;
  }

  .voice-interview-completion-step-desc {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Interview/VoiceInterview/VoiceInterview.css"],"names":[],"mappings":"AAAA;;;+CAG+C;;AAI/C;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,8CAA8C;EAC9C,0DAA0D;EAC1D,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,aAAa,EAAE,uCAAuC;EACtD,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB,EAAE,wBAAwB;EAC1C,oEAAoE;AACtE;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA,uCAAuC;AACvC;EACE,OAAO;EACP,aAAa;EACb,SAAS;EACT,aAAa;EACb,oBAAoB,EAAE,qDAAqD;EAC3E,gBAAgB,EAAE,wCAAwC;EAC1D,+BAA+B,EAAE,2BAA2B;AAC9D;;AAEA,+CAA+C;AAC/C;EACE;IACE,oBAAoB,EAAE,qDAAqD;EAC7E;AACF;;AAEA;EACE;IACE,oBAAoB,EAAE,wCAAwC;EAChE;AACF;;AAEA,6CAA6C;AAC7C;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB,EAAE,6CAA6C;EAC/D,aAAa,EAAE,6DAA6D;EAC5E,eAAe,EAAE,qBAAqB;AACxC;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,2BAA2B,EAAE,wBAAwB;EACrD,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,WAAW,WAAW,EAAE;EACxB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,qCAAqC;AACrC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0EAA0E;EAC1E,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ==========================================\n   VOICE INTERVIEW SCREEN - G42 BRANDING\n   Dark theme for interview experience\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n:root {\n  --voice-bg-dark: #0A1F1C;\n  --voice-bg-darker: #071613;\n  --voice-card-bg: #0F2A25;\n  --voice-card-light: #13342E;\n  --voice-text-primary: #E5F2ED;\n  --voice-text-secondary: #A8C5BB;\n  --voice-text-muted: #6B8B7F;\n  --voice-border: #1A3F38;\n  --voice-accent: var(--interview-brand-primary);\n  --voice-accent-hover: var(--interview-brand-primary-hover);\n  --voice-recording: #DC2626;\n  --voice-proctored: var(--interview-brand-primary);\n}\n\n.voice-interview-container {\n  height: 100vh; /* Fixed height instead of min-height */\n  background: var(--voice-bg-dark);\n  display: flex;\n  flex-direction: column;\n  font-family: var(--interview-font-primary);\n  color: var(--voice-text-primary);\n  position: relative;\n  overflow: hidden; /* Prevent body scroll */\n  /* No extra padding needed - video is floating in top-right corner */\n}\n\n/* ========== HEADER ========== */\n.voice-interview-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background: var(--voice-bg-darker);\n  border-bottom: 1px solid var(--voice-border);\n  gap: 24px;\n}\n\n.voice-interview-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.voice-interview-logo {\n  flex-shrink: 0;\n}\n\n.voice-interview-brand-text {\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--voice-text-primary);\n}\n\n.voice-interview-header-badges {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.voice-interview-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid;\n}\n\n.voice-interview-badge-recording {\n  background: rgba(220, 38, 38, 0.1);\n  border-color: rgba(220, 38, 38, 0.3);\n  color: #FCA5A5;\n}\n\n.voice-interview-recording-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--voice-recording);\n  animation: pulse-dot 2s ease-in-out infinite;\n}\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n.voice-interview-badge-proctored {\n  background: rgba(15, 157, 107, 0.1);\n  border-color: rgba(15, 157, 107, 0.3);\n  color: #6EE7B7;\n}\n\n.voice-interview-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n\n.voice-interview-person-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--voice-text-secondary);\n  background: var(--voice-card-bg);\n  padding: 8px 14px;\n  border-radius: 20px;\n  border: 1px solid var(--voice-border);\n}\n\n.voice-interview-timer-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--voice-card-bg);\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1px solid var(--voice-border);\n}\n\n.voice-interview-timer {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--voice-text-primary);\n  font-variant-numeric: tabular-nums;\n}\n\n.voice-interview-toggle-btn {\n  background: var(--voice-card-bg);\n  border: 1px solid var(--voice-border);\n  color: var(--voice-text-secondary);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.voice-interview-toggle-btn:hover {\n  background: var(--voice-card-light);\n  color: var(--voice-text-primary);\n  border-color: var(--voice-accent);\n}\n\n/* ========== MAIN CONTENT ========== */\n.voice-interview-content {\n  flex: 1;\n  display: flex;\n  gap: 24px;\n  padding: 24px;\n  padding-right: 356px; /* 300px video width + 28px right margin + 28px gap */\n  overflow: hidden; /* Prevent main content from scrolling */\n  max-height: calc(100vh - 160px); /* Header + Footer height */\n}\n\n/* Responsive adjustments for video clearance */\n@media (max-width: 768px) {\n  .voice-interview-content {\n    padding-right: 244px; /* 220px video width + 12px right margin + 12px gap */\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .voice-interview-content {\n    padding-right: 300px; /* 260px video width + 28px + 12px gap */\n  }\n}\n\n/* ========== TRANSCRIPT SECTION ========== */\n.voice-interview-transcript-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--voice-card-bg);\n  border-radius: 16px;\n  border: 1px solid var(--voice-border);\n  overflow: hidden; /* Important: prevents section from growing */\n  min-height: 0; /* Important: allows flex item to shrink below content size */\n  max-width: 100%; /* Prevent overflow */\n}\n\n.voice-interview-question-header {\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--voice-border);\n}\n\n.voice-interview-question-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: var(--voice-accent);\n  display: block;\n  margin-bottom: 12px;\n}\n\n.voice-interview-progress-bar {\n  height: 6px;\n  background: var(--voice-bg-darker);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.voice-interview-progress-fill {\n  height: 100%;\n  background: var(--voice-accent);\n  border-radius: 3px;\n  transition: width 0.5s ease;\n}\n\n.voice-interview-hint {\n  padding: 0 24px;\n  font-size: 12px;\n  color: var(--voice-text-muted);\n  margin: 12px 0;\n}\n\n.voice-interview-transcript {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.voice-interview-transcript::-webkit-scrollbar {\n  width: 8px;\n}\n\n.voice-interview-transcript::-webkit-scrollbar-track {\n  background: var(--voice-bg-darker);\n  border-radius: 4px;\n}\n\n.voice-interview-transcript::-webkit-scrollbar-thumb {\n  background: var(--voice-border);\n  border-radius: 4px;\n}\n\n.voice-interview-transcript::-webkit-scrollbar-thumb:hover {\n  background: var(--voice-card-light);\n}\n\n.voice-interview-transcript-empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--voice-text-muted);\n  font-size: 14px;\n}\n\n.voice-interview-message {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  max-width: 85%;\n}\n\n/* Agent messages aligned left */\n.voice-interview-message-agent {\n  align-self: flex-start;\n}\n\n/* Candidate messages aligned right */\n.voice-interview-message-candidate {\n  align-self: flex-end;\n  flex-direction: row-reverse; /* Avatar on the right */\n  margin-left: auto;\n}\n\n.voice-interview-message-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.voice-interview-message-agent .voice-interview-message-avatar {\n  background: #0A6E4A;\n  color: #fff;\n}\n\n.voice-interview-message-candidate .voice-interview-message-avatar {\n  background: #3D5560;\n  color: #fff;\n}\n\n.voice-interview-message-bubble {\n  flex: 1;\n  padding: 13px 17px;\n  border-radius: 16px;\n  font-size: 14.5px;\n  line-height: 1.6;\n  color: var(--voice-text-primary);\n  word-wrap: break-word;\n}\n\n.voice-interview-message-agent .voice-interview-message-bubble {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #D8EFE4;\n  border-top-left-radius: 4px;\n}\n\n.voice-interview-message-candidate .voice-interview-message-bubble {\n  background: var(--voice-accent);\n  color: #fff;\n  border-top-right-radius: 4px;\n}\n\n.voice-interview-listening-indicator {\n  display: flex;\n  justify-content: center;\n  padding: 16px;\n}\n\n.voice-interview-dot-wave {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.voice-interview-dot-wave span {\n  width: 8px;\n  height: 8px;\n  background: var(--voice-accent);\n  border-radius: 50%;\n  animation: wave 1.2s ease-in-out infinite;\n}\n\n.voice-interview-dot-wave span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.voice-interview-dot-wave span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes wave {\n  0%, 60%, 100% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  30% {\n    transform: scale(1.3);\n    opacity: 1;\n  }\n}\n\n.voice-interview-instructions {\n  padding: 16px 24px;\n  border-top: 1px solid var(--voice-border);\n  font-size: 12px;\n  color: var(--voice-text-muted);\n  text-align: center;\n}\n\n/* ========== VIDEO SECTION ========== */\n.voice-interview-video-section {\n  width: 320px;\n  flex-shrink: 0;\n  position: relative;\n  background: var(--voice-bg-darker);\n  border-radius: 16px;\n  border: 1px solid var(--voice-border);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.voice-interview-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform: scaleX(-1);\n}\n\n.voice-interview-video-label {\n  position: absolute;\n  bottom: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(10, 31, 28, 0.9);\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  color: var(--voice-text-secondary);\n  border: 1px solid var(--voice-border);\n}\n\n/* ========== FOOTER CONTROLS ========== */\n.voice-interview-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  padding: 20px 24px;\n  background: var(--voice-bg-darker);\n  border-top: 1px solid var(--voice-border);\n}\n\n.voice-interview-mic-btn {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--voice-accent);\n  border: none;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.voice-interview-mic-btn:hover:not(:disabled) {\n  background: var(--voice-accent-hover);\n  transform: scale(1.05);\n}\n\n.voice-interview-mic-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.voice-interview-mic-btn.voice-interview-mic-muted {\n  background: var(--voice-recording);\n}\n\n.voice-interview-listening-bar {\n  flex: 1;\n  max-width: 400px;\n  height: 56px;\n  background: var(--voice-card-bg);\n  border-radius: 28px;\n  border: 1px solid var(--voice-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 0 24px;\n}\n\n.voice-interview-sound-bars {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  height: 28px;\n}\n\n.voice-interview-sound-bar {\n  width: 3px;\n  background: var(--voice-accent);\n  border-radius: 2px;\n  animation: sound-bar 1s ease-in-out infinite;\n}\n\n@keyframes sound-bar {\n  0%, 100% { height: 8px; }\n  50% { height: 24px; }\n}\n\n.voice-interview-listening-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--voice-accent);\n}\n\n.voice-interview-listening-text.voice-interview-listening-idle {\n  color: var(--voice-text-muted);\n}\n\n.voice-interview-action-buttons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.voice-interview-pause-btn,\n.voice-interview-end-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: 24px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: var(--interview-font-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid var(--voice-border);\n}\n\n.voice-interview-pause-btn {\n  background: var(--voice-card-bg);\n  color: var(--voice-text-primary);\n}\n\n.voice-interview-pause-btn:hover:not(:disabled) {\n  background: var(--voice-card-light);\n  border-color: var(--voice-accent);\n}\n\n.voice-interview-pause-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.voice-interview-end-btn {\n  background: transparent;\n  color: var(--voice-text-secondary);\n}\n\n.voice-interview-end-btn:hover:not(:disabled) {\n  background: rgba(220, 38, 38, 0.1);\n  border-color: var(--voice-recording);\n  color: #FCA5A5;\n}\n\n.voice-interview-end-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ========== OVERLAYS ========== */\n.voice-interview-start-overlay,\n.voice-interview-connecting-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(10, 31, 28, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  backdrop-filter: blur(8px);\n}\n\n.voice-interview-start-card {\n  background: var(--voice-card-bg);\n  border: 1px solid var(--voice-border);\n  border-radius: 20px;\n  padding: 48px 56px;\n  text-align: center;\n  max-width: 480px;\n}\n\n.voice-interview-start-card h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--voice-text-primary);\n  margin: 0 0 16px;\n}\n\n.voice-interview-start-card p {\n  font-size: 15px;\n  color: var(--voice-text-secondary);\n  margin: 0 0 32px;\n  line-height: 1.6;\n}\n\n.voice-interview-start-btn {\n  width: 100%;\n  padding: 16px 32px;\n  background: var(--voice-accent);\n  color: white;\n  border: none;\n  border-radius: 13px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: var(--interview-font-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.voice-interview-start-btn:hover {\n  background: var(--voice-accent-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(15, 157, 107, 0.3);\n}\n\n.voice-interview-connecting-overlay {\n  flex-direction: column;\n  gap: 20px;\n}\n\n.voice-interview-connecting-overlay p {\n  font-size: 16px;\n  color: var(--voice-text-secondary);\n}\n\n.voice-interview-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--voice-border);\n  border-top-color: var(--voice-accent);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ========== RESPONSIVE ========== */\n@media (max-width: 1200px) {\n  .voice-interview-content {\n    flex-direction: column;\n  }\n\n  .voice-interview-video-section {\n    width: 100%;\n    height: 240px;\n  }\n}\n\n@media (max-width: 768px) {\n  .voice-interview-header {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .voice-interview-header-right {\n    order: 3;\n    flex-basis: 100%;\n    justify-content: space-between;\n  }\n\n  .voice-interview-footer {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .voice-interview-listening-bar {\n    flex-basis: 100%;\n    order: 3;\n  }\n\n  .voice-interview-video-section {\n    height: 180px;\n  }\n}\n\n/* ========== COMPLETION SCREEN ========== */\n.voice-interview-completion {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n  background: linear-gradient(160deg, #0E2C24 0%, #0A5C3A 60%, #0F9D6B 100%);\n  font-family: var(--interview-font-primary);\n  text-align: center;\n}\n\n.voice-interview-completion-content {\n  max-width: 520px;\n  width: 100%;\n}\n\n.voice-interview-completion-brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 48px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.voice-interview-completion-checkmark {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 32px;\n  color: #7EEFC4;\n}\n\n.voice-interview-completion-title {\n  font-size: 36px;\n  font-weight: 800;\n  color: #fff;\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n}\n\n.voice-interview-completion-subtitle {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.6;\n  margin-bottom: 42px;\n  max-width: 440px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.voice-interview-completion-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 42px;\n}\n\n.voice-interview-completion-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 14px;\n  padding: 18px 20px;\n  text-align: left;\n  transition: background 0.2s ease;\n}\n\n.voice-interview-completion-step:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.voice-interview-completion-step-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #7EEFC4;\n}\n\n.voice-interview-completion-step-text {\n  flex: 1;\n  padding-top: 2px;\n}\n\n.voice-interview-completion-step-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.voice-interview-completion-step-desc {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.5;\n}\n\n.voice-interview-completion-link {\n  color: #7EEFC4;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.voice-interview-completion-link:hover {\n  color: #9FF5D4;\n}\n\n.voice-interview-completion-footer {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.5);\n  line-height: 1.6;\n  max-width: 420px;\n}\n\n/* Responsive for completion screen */\n@media (max-width: 768px) {\n  .voice-interview-completion {\n    padding: 24px 20px;\n  }\n\n  .voice-interview-completion-title {\n    font-size: 28px;\n  }\n\n  .voice-interview-completion-subtitle {\n    font-size: 15px;\n    margin-bottom: 32px;\n  }\n\n  .voice-interview-completion-step {\n    padding: 16px;\n  }\n\n  .voice-interview-completion-step-icon {\n    width: 36px;\n    height: 36px;\n  }\n\n  .voice-interview-completion-step-title {\n    font-size: 14px;\n  }\n\n  .voice-interview-completion-step-desc {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
